import tagService from "@/services/tag.service.js"
import counterService from "@/services/counter.service.js"

export const Tags = {
	namespaced : true,
	state :{
		list: [
			{ name: "objects", list : [ 
				{ name : 'person'}, 
				{ name : 'gun'}, 
				// 'lpr', 
				{ name : 'car'}, 
				{ name : 'laptop'}, 
				{ name : 'truck'}, 
				{ name :'motorcycle'}, 
				{ name : 'bus'}, 
				{ name : 'knife'} 
				], 
			},
			{ name: "lpr", list : [ { name :'lpr'}], },
			{ name: "face", list: [{ name :'face'}], }, 
			{ name: "anomalies", list : ['anomalies'] }, 
			{ name: "actions", list : [
				{ name :'hands_up'}, 
				{ name :'walking'}, 
				{ name :'fighting'}, 
				{ name :'calling'}, 
				{ name :'falling'}, 
				{ name :'sitting'}, 
				{ name :'standing'}
				], 
			}, 
			{ name: "motion", list : [{ name :'motion'}], },
			// { name: "", list  : ['required_select_analytic'], },
			{ name: "avc", list : [ { name :'avc'} ], },
			{ name: "smart_event", list	: [], isRequest: true, },
			{ name: "data", list : [], isRequest: true, }, // realizar consulta 

			
		],
		isLoaded : false,
		isLoadedData : false,
		isLoadingData : false,
		isLoadedSmartEvent : false,
		isLoadingSmartEvent : false,
	},
	getters:{
		getList: (state)=> {
	        return state.list;
	    },
	    getIsLoaded: (state)=>{
	    	return state.isLoaded;
	    },
	    getBySelect:(state)=>(name)=>{
	    	return state.list.length > 0 ? state.list.find(x=> x.name == name ): []
	    },
	    getIsLoadedData:(state)=>{
	    	return state.isLoadedData;
	    },
	    getIsLoadedSmartEvent:(state)=>{
	    	return state.isLoadedSmartEvent;
	    },

	},
	actions:{
		getList({commit}){
			// console.log("LIST ", analyticService)
			tagService.getList().then(res=>{
				// console.log("Finish get list for face ", res)
				commit("setList",res)
				commit("setIsLoaded",true)

			}).catch(erro=>{
				console.warn("Error get list tags ", error)
			});
		},
		getListData({state, commit}){
			if (!state.isLoadingData) {				
				commit("setLoadingData",true)
				counterService.getList().then(res=>{
					// console.log("Finish get list for face ", res)
					if (res && res.data && res.data.rows && res.data.rows.length) {					
						commit("setListData",res.data.rows.filter(counter => counter.typeCounter == "custom"))
						commit("setIsLoaded",true)
					}
					commit("setLoadingData",false)
				}).catch(erro=>{
					console.warn("Error get list data ", error)
					commit("setLoadingData",false)
				});
			}
		},
	},
	mutations:{
		setList(state, list) {
      		state.list = list;
	    },
	    setIsLoaded(state, val){
	    	state.isLoaded=val;
	    },
	    isLoadedData(state, val){
	    	state.isLoadedData=val;
	    },
	    setLoadingData(state, val){
	    	state.isLoadindData=val;
	    },
	    setInList(state, name, list){
	    	const idx=state.list.findIndex(x=> x.name == name)
	    	if (idx>=0) {
	    		state.list[idx].list=list;
	    	}

	    },
	    setListData(state, list) {
      		const idx=state.list.findIndex(x=> x.name=='data');
      		if (idx>=0) {
      			state.list[idx].list = list;
      		}
	    },
	    setListSmartEvent(state, list) {
      		const idx=state.list.findIndex(x=> x.name=='smart_event');      		
      		if (idx>=0) {
      			state.list[idx].list = list;
	    		state.isLoadedSmartEvent=true;
      		}
	    },
		setIsLoadedData(state, val){
	    	state.isLoadedData=val;
	    },
	   
	},
}